import React from 'react';

// style
import './style.scss';

export default function ProjectModal({
  name,
  projectImage,
  details,
  alt,
  active,
  gitlink,
  live,
  createdWith,
  onClick,
}) {
  return (
    <div className={active ? 'project-modal modal-active' : 'project-modal'}>
      <div className="close" onClick={onClick}>
        <i className="fas fa-times"></i>
      </div>
      <img
        className="modal-project-img"
        loading="lazy"
        src={`https://portfolio-backend-tousif.herokuapp.com/images/${projectImage}`}
        alt={alt}
      />
      <h2 className="modal-project-name">{name}</h2>
      <p className="modal-project-details">{details}</p>
      <div className="created-with">
        {createdWith.map((language) => (
          <p className="language" key={language._id}>
            {language.language}
          </p>
        ))}
      </div>
      <div className="links">
        <a href={live} className="live-link" target="_blank" rel="noreferrer">
          Visit{' '}
          <span>
            <i className="fas fa-external-link-alt"></i>
          </span>
        </a>
        <a href={gitlink} className="git-link" target="_blank" rel="noreferrer">
          Code{' '}
          <span>
            <i className="fab fa-github"></i>
          </span>
        </a>
      </div>
    </div>
  );
}
